import { ILinkStyles, IStyle } from '@fluentui/react';
import { CommonStyles } from '@h2oai/ui-kit';

export interface IScheduledTaskListStyles {
  root?: IStyle;
  cardView?: IStyle;
  actions?: IStyle;
  actionButtons?: IStyle;
}

export interface IScheduledTaskListClassNames {
  root: string;
  cardView: string;
  actions: string;
  actionButtons: string;
}

export const scheduledTaskListStylesDefault: Partial<IScheduledTaskListStyles> = {
  root: {
    display: 'flex',
    flex: 1,
    minHeight: 0,
  },
  cardView: {
    flex: 1,
    overflow: 'auto',
  },
  actions: {
    ...CommonStyles.flexCenterVertically,
    width: '100%',
  },
  actionButtons: {
    display: 'flex',
    gap: '8px',
    justifyContent: 'flex-end',
  },
};

// TODO: Move this to ui-kit
export const linkStylesIconOnly: Partial<ILinkStyles> = {
  root: { padding: '0 8px' },
};
